import { render, staticRenderFns } from "./u-btn-custom.vue?vue&type=template&id=a67a5010&scoped=true&"
import script from "./u-btn-custom.vue?vue&type=script&lang=js&"
export * from "./u-btn-custom.vue?vue&type=script&lang=js&"
import style0 from "./u-btn-custom.vue?vue&type=style&index=0&id=a67a5010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67a5010",
  null
  
)

export default component.exports